import { useTranslation } from 'react-i18next'
import { Select } from 'antd'
import { Languages } from 'lucide-react'

export function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language || 'en'

  const handleLanguageChange = (lang: string) => {
    void i18n.changeLanguage(lang)
  }

  return (
    <div className="flex items-center gap-1.5 border border-border rounded-lg bg-background/50 hover:bg-muted/30 transition-colors pl-2.5 pr-1 py-0.5 shadow-sm shrink-0">
      <Languages className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
      <Select
        value={currentLanguage}
        onChange={handleLanguageChange}
        variant="borderless"
        popupClassName="leap-i18n-popup font-medium"
        className="h-6 w-24 text-xs font-semibold text-foreground bg-transparent focus:ring-0 focus:outline-none select-language-custom"
        options={[
          { value: 'en', label: 'English' },
          { value: 'ar', label: ' العربية' },
        ]}
      />
      <style>{`
        .select-language-custom .ant-select-selector {
          padding: 0 !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          color: hsl(var(--foreground)) !important;
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }
        .select-language-custom .ant-select-arrow {
          color: hsl(var(--muted-foreground)) !important;
          font-size: 10px !important;
          right: 4px !important;
        }
        .leap-i18n-popup {
          background-color: hsl(var(--background)) !important;
          border: 1px solid hsl(var(--border)) !important;
          border-radius: 8px !important;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
          padding: 4px !important;
        }
        .leap-i18n-popup .ant-select-item {
          border-radius: 6px !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          color: hsl(var(--foreground)) !important;
          padding: 5px 8px !important;
        }
        .leap-i18n-popup .ant-select-item-option-selected {
          background-color: hsl(var(--primary) / 0.1) !important;
          color: hsl(var(--primary)) !important;
          font-weight: 600 !important;
        }
        .leap-i18n-popup .ant-select-item-option-active {
          background-color: hsl(var(--muted)) !important;
        }
      `}</style>
    </div>
  )
}
